
import { IconCurrencyRupee, IconTrendingUp } from '@tabler/icons-react'
export const SalesStatsCard = ({ analyticsData, statsData }) => {
    console.log("analyticsData", analyticsData)

    const invoice = {
        amount: analyticsData?.invoices?.current_amount || 0,
        percentage: analyticsData?.invoices?.percentage || 0,
    }
    const conversion = {
        total: analyticsData?.leadToDeals || 0,
        percentage: analyticsData?.percentage || 0
    }

    return (
        <div

            className='d-flex gap-3'
            style={{
                boxSizing: 'border-box'
            }}
        >
            {/* <StatsData
                customStyles={{ background: "linear-gradient(-45deg, #6d3fd1 0%, #8253e4 45%, #a57cff 100%)", color: 'white' }}
                label={"Total Revenue"}
                icon={<FontAwesomeIcon icon={faWallet} size={"lg"} style={{ color: 'white', }} />}
                percent={invoice?.percentage}
                value={putCommaInLeadsValue(invoice?.amount)}
                iconBg="#7539ff"
                isCurrency={true}
            /> */}
            {
                statsData?.map((c, idx) => {
                    return <StatsData key={idx} label={c.label} icon={c.icon} value={c.value} percent={c.percent} iconBg={c.iconBg} isCurrency={c.isCurrency} />
                })
            }

        </div>
    )
}

export const StatsData = ({ label, icon, value, percent, iconBg, customClassname, customStyles, isCurrency }) => {
    return <div
        className={`p-3 d-flex flex-column gap-4  justify-content-between ${customClassname} `}
        style={{ backgroundColor: "#fff", height: "12rem", width: "100%", boxShadow: "0px 4px 3px 0px rgba(126, 126, 126, 0.1)", borderRadius: "0.625rem", border: "1px solid #e3e3e3", ...customStyles }}
    >
        <div className='d-flex gap-2 justify-content-between align-items-start '>
            {/* icon */}
            <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                    background: iconBg,
                    width: "2rem",
                    height: "2rem",
                    borderRadius: "0.625rem",
                    boxShadow: "0 2px 8px rgba(122, 58, 94, 0.08)"
                }}
            >
                {icon}
            </div>

            {/* label */}
            <div className='d-flex flex-column align-items-end'>
                <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>
                    {label}
                </span>
                <span className="d-flex align-items-center mb-0 pb-0 self-end" style={{ fontWeight: 400, fontSize: '1.8em' }}>
                    {isCurrency && <IconCurrencyRupee size={30} stroke={2} />}
                    {value}
                </span>
            </div>
        </div>

        {/* <div className='d-flex flex-column justify-content-start align-items-end'> */}

        <div style={{ display: 'flex', flexDirection: "column", alignItems: 'start' }}>
            <span className={`fs-14 }`} style={{ fontWeight: 600, color: "#27ae60" }} >
                {percent}
                <IconTrendingUp size={14} stroke={2} />
            </span>
            <span style={{ fontWeight: 500, fontSize: "12px" }}>From Last Week</span>
        </div>
        {/* </div> */}
    </div >
}